<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        :title="WorkLineInfoCName.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="WorkLineInfoCName"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="工序名称">
          <el-input v-model="WorkLineInfoCName.processName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="工序编号">
          <el-input v-model="WorkLineInfoCName.code" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="显示排序">
          <el-input v-model="WorkLineInfoCName.showOrder" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input v-model="WorkLineInfoCName.remark" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "../../../util/constants";

  export default {
    name:"WorkLineInfoCNameEdit",
    components: {},
    data() {
      return {
        constants,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        index: "",
        WorkLineInfoCName: {
          processName: "",
          code: "",
          showOrder: "",
          remark: "",
          pkid: "",
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(row,index) {
        this.index = index;
        this.dialogVisible = true;
        if(row) {
          this.WorkLineInfoCName = row;
        }
      },
      handleSubmit() {
        if(this.index<0) {
          this.dialogVisible = false;
          this.$emit("save-success",this.WorkLineInfoCName);
        }else {
          this.dialogVisible = false;
          this.$emit("save-success",this.WorkLineInfoCName,this.index);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
